const urls = {
    VESSEL_PROTOCOL_BY_LOT_ID: 'vessel-protocol-by-lot-id',
    VESSEL_PROTOCOL_CHANGE_STATUS: 'vessel-protocol/change-status',
    VESSEL_PROTOCOL_CI_GOODS_DESTINATION: 'vessel-protocol-ci-goods-destination',
    VESSEL_PROTOCOL_CUSTOMS_INFORMATION: 'vessel-protocol-customs-information',
    VESSEL_PROTOCOL_MANUAL_CHANGE: 'vessel-protocol/manual-change',
    VESSEL_PROTOCOL_VALUE_REVIEW: 'vessel-protocol-ci-value-review-declaration',
    VESSEL_PROTOCOL_INCOMING_GOODS_MANIFEST: 'vessel-protocol-ci-incoming-goos-manifest',
    VESSEL_PROTOCOL_GOODS_DESTINATION: 'vessel-protocol-ci-goods-destination',
    VESSEL_PROTOCOL_CHECK_LOTS: 'vessel-protocol-check-lots',
    VESSEL_PROTOCOL_LINK_LOT: 'vessel-protocol/link-lot',
    VESSEL_PROTOCOL_LOADING: 'vessel-protocol-loading',
    VESSEL_PROTOCOL_DISCHARGE: 'vessel-protocol-discharge',
    VESSEL_PROTOCOL_DISCHARGE_CALCULATE: 'vessel-protocol-discharge-calculate',
    VESSEL_PROTOCOL_PREVISIONAL_COMMERCIAL_INFO: 'vessel-protocol-previsional-commercial-information',
    VESSEL_PROTOCOL_FINAL_COMMERCIAL_INFO: 'vessel-protocol-final-commercial-information',
    VESSEL_PROTOCOL_PAYMENTS: 'vessel-protocol-payments',
    VESSEL_PROTOCOL_FINAL_COMMERCIAL_DOCUMENT: 'vessel-protocol-final-commercial-information-document',
    MASTER_DATA_VAT: 'masterdata/vat',
    VESSEL_PROTOCOL_PCI_CALCULATION: 'vessel-protocol-pci-calculation',
    VESSEL_PROTOCOL_FCI_CALCULATION: 'vessel-protocol-fci-calculation',
    VESSEL_PROTOCOL_REPORT_PRINT: 'vessel-protocol-report-data-print-preview',
    VESSEL_PROTOCOL_REPORT_7: 'vessel-protocol-report-data-create-report-7',
    VESSEL_PROTOCOL_REPORT_11: 'vessel-protocol-report-data-create-report-11',
    VESSEL_PROTOCOL_REPORT_12: 'vessel-protocol-report-data-create-report-12',
    VESSEL_PROTOCOL_REPORT_13: 'vessel-protocol-report-data-create-report-13',
    VESSEL_PROTOCOL_REPORT_13: 'vessel-protocol-report-data-create-report-13',
    VESSEL_PROTOCOL_REPORT_14: 'vessel-protocol-report-data-create-report-14',
    VESSEL_PROTOCOL_REPORT_16: 'vessel-protocol-report-data-create-report-16',
    VESSEL_PROTOCOL_REPORT_23: 'vessel-protocol-report-data-create-report-23',
    VESSEL_PROTOCOL_REPORT_24: 'vessel-protocol-report-data-create-report-24',
    VESSEL_PROTOCOL_REPORT_28: 'vessel-protocol-report-data-create-report-28',
    VESSEL_PROTOCOL_REPORT_30: 'vessel-protocol-report-data-create-report-30',
    VESSEL_PROTOCOL_REPORT_31: 'vessel-protocol-report-data-create-report-31',
    VESSEL_PROTOCOL_REPORT_33: 'vessel-protocol-report-data-create-report-33',
    VESSEL_PROTOCOL_REPORT_36: 'vessel-protocol-report-data-create-report-36',
    VESSEL_PROTOCOL_REPORT_37: 'vessel-protocol-report-data-create-report-37',
    VESSEL_PROTOCOL_REPORT_38: 'vessel-protocol-report-data-create-report-38',
    VESSEL_PROTOCOL_REPORT_39: 'vessel-protocol-report-data-create-report-39',
    VESSEL_PROTOCOL_REPORT_40: 'vessel-protocol-report-data-create-report-40',
    VESSEL_PROTOCOL_REPORT_41: 'vessel-protocol-report-data-create-report-41',
    VESSEL_PROTOCOL_REPORT_42: 'vessel-protocol-report-data-create-report-42',
    VESSEL_PROTOCOL_REPORT_44: 'vessel-protocol-report-data-create-report-44',
    VESSEL_PROTOCOL_REPORT_45: 'vessel-protocol-report-data-create-report-45',
    VESSEL_PROTOCOL_REPORT_47: 'vessel-protocol-report-data-create-report-47',
    VESSEL_PROTOCOL_REPORT_52: 'vessel-protocol-report-data-create-report-52',
    VESSEL_PROTOCOL_REPORT_53: 'vessel-protocol-report-data-create-report-53',
    VESSEL_PROTOCOL_REPORT_54: 'vessel-protocol-report-data-create-report-54',
    VESSEL_PROTOCOL_REPORT_71: 'vessel-protocol-report-data-create-report-71',
    VESSEL_PROTOCOL_REPORT_72: 'vessel-protocol-report-data-create-report-72',
    VESSEL_PROTOCOL_REPORT_4: 'vessel-protocol-report-data-create-report-4',
    VESSEL_PROTOCOL_REPORT_4_EXCEL: 'vessel-protocol-report-data-extract-report-4-excel',
    VESSEL_PROTOCOL_REPORT_57: 'vessel-protocol-report-data-create-report-57',
    VESSEL_PROTOCOL_ISTANCE_REPORT: 'vessel-protocol-payment-istance-report-save',
    VESSEL_PROTOCOL_ISTANCE_REPORT_PRINT: 'vessel-protocol-payment-istance-report-print',
    VESSEL_PROTOCOL_ISTANCE_REPORT_PRINT_EXCEL: 'vessel-protocol-payment-istance-report-extract-excel',
    VESSEL_PROTOCOL_CI_GOODS_DESTINATION: 'vessel-protocol-ci-goods-destination',
    VESSEL_PROTOCOL_TO_MONGO_DB: 'vessel-protocol-to-mongo-db',
    VESSEL_PROTOCOL_REPORT_PORTUAL_TAX: 'vessel-protocol-report-data-create-report-portual-tax',
    
    VESSEL_PROTOCOL_DOCUMENT_MANAGER: 'vessel-protocol-report-data-upload-file-from-gui',
    VESSEL_PROTOCOL_DOCUMENT_MANAGER_DOWNLOAD: 'system/document-manager-download-document',
    VESSEL_PROTOCOL_ATTACHMENTS_BY_VESSEL_PROTOCOL_ID: 'vessel-protocol-get-document-from-archiflow',
    VESSEL_PROTOCOL_ATTACHMENTS_DELETE_BY_ID: 'vessel-protocol-report-data',
    VESSEL_PROTOCOL_SEND_EMAIL: 'vessel-protocol-report-data-document-send-email',
    VESSEL_PROTOCOL_SEND_EMAIL_REPORT_52: 'vessel-protocol-report-data-send-email-52',
    VESSEL_PROTOCOL_SEND_EMAIL_REPORT_53: 'vessel-protocol-report-data-send-email-53',
    VESSEL_PROTOCOL_CHECK_VALUE_REVIEW: 'vessel-protocol-check-value-review',
    VESSEL_PROTOCOL_SEND_EMAIL_PAYMENTS: 'vessel-protocol-payments-send-email?idVesselProtocolPayment=',

    VESSEL_PROTOCOL_CUSTOMS_INFORMATION_BOLLA_AIDA: 'vessel-protocol-customs-information-bolla-aida',
    VESSEL_PROTOCOL_REPORT_DATA_GET_ADDRESS: 'vessel-protocol-report-data-get-address',

    VESSEL_PROTOCOL_PRINT_LOADING_REPORT: 'vessel-protocol-loading-print-report-sim-web',
    VESSEL_PROTOCOL_PRINT_DISCHARGE_REPORT: 'vessel-protocol-discharge-print-report-sim-web',


    RAW_MATERIAL_CHECK: 'vessel-protocol-discharge-raw-material-check',
    RAW_MATERIAL_CHECK_NOTE: 'vessel-protocol-discharge-raw-material-check-notes',
    RAW_MATERIAL_CHECK_NOTE_CLONE: 'vessel-protocol-discharge-raw-material-check-notes-clone',
    RAW_MATERIAL_CHECK_NOTES_ASSOCIATE: 'vessel-protocol-discharge-raw-material-check-notes-associate',
    RAW_MATERIAL_CHECK_IMPORT_ANALYSIS_VALUES: 'vessel-protocol-discharge-raw-material-check-import-analysis-values',
    RAW_MATERIAL_CHECK_EXPORT_EXCEL: 'vessel-protocol-discharge-raw-material-check-export-excel',

    DISCHARGE_TRACKING_BY_PROTOCOL_ID: 'vessel-protocol-discharge-tracking-by-vessel-protocol-id',

    VESSEL_PROTOCOL_TRIBUTE_RESEARCH_EXPORT_EXCEL: 'vessel-protocol-payments-tribute-research-excel',
    VESSEL_PROTOCOL_TRIBUTE_RESEARCH_EXCEL_PRINT: 'vessel-protocol-payments-tribute-research-print-excel',
    VESSEL_PROTOCOL_PROTOCOL_EXPORT_EXCEL: 'vessel-protocol-search-protocols-excel',
    VESSEL_PROTOCOL_PROTOCOL_EXPORT_EXCEL_PRINT: 'vessel-protocol-to-mongo-db-print-excel',
    VESSEL_PROTOCOL: 'vessel-protocol',

    VESSEL_PROTOCOL_SCHEDULING_ATTACHMENTS_BY_VESSEL_PROTOCOL_ID: 'vessel-protocol/get-document-attuazione',
    VESSEL_PROTOCOL_ZIP_DOCUMENTS: 'vessel-protocol/download-zip-document-attuazione',
        
}

import genericService from '../genericService';

export default {
    async getVesselProtocolByLotId(body, callback){
        await genericService.get(urls.VESSEL_PROTOCOL_BY_LOT_ID, body).then(callback);
    },
    async changeVesselProtocolStatus(body, callback){
        await genericService.put(urls.VESSEL_PROTOCOL_CHANGE_STATUS, body).then(callback);
    },
    async getVesselProtocolCustomsInformation(body, callback){
        await genericService.get(urls.VESSEL_PROTOCOL_CUSTOMS_INFORMATION, body).then(callback);
    },
    async addVesselProtocolCustomsInformation(body, callback){
        await genericService.post(urls.VESSEL_PROTOCOL_CUSTOMS_INFORMATION, body).then(callback);
    },
    async updateVesselProtocolCustomsInformation(body, callback){
        await genericService.put(urls.VESSEL_PROTOCOL_CUSTOMS_INFORMATION, body).then(callback);
    },
    async manualChangeVesselProtocol(body, callback){
        await genericService.post(urls.VESSEL_PROTOCOL_MANUAL_CHANGE, body).then(callback);
    },
    async addValueReviewVesselProtocol(body, callback){
        await genericService.post(urls.VESSEL_PROTOCOL_VALUE_REVIEW, body).then(callback);
    },
    async addIncomingGoodsManifestVesselProtocol(body, callback){
        await genericService.post(urls.VESSEL_PROTOCOL_INCOMING_GOODS_MANIFEST, body).then(callback);
    },
    async addGoodsDestinationVesselProtocol(body, callback){
        await genericService.post(urls.VESSEL_PROTOCOL_GOODS_DESTINATION, body).then(callback);
    },
    async checkVesselProtocolLots(body, callback){
        await genericService.get(urls.VESSEL_PROTOCOL_CHECK_LOTS, body).then(callback);
    },
    async linkLotToVesselProtocol(body, callback){
        await genericService.post(urls.VESSEL_PROTOCOL_LINK_LOT, body).then(callback);
    },
    async getVesselProtocolLoading(id, callback){
        await genericService.getItem(urls.VESSEL_PROTOCOL_LOADING, id).then(callback);
    },
    async updateVesselProtocolLoading(body, callback){
        await genericService.put(urls.VESSEL_PROTOCOL_LOADING, body).then(callback);
    },
    async addVesselProtocolLoading(body, callback){
        await genericService.post(urls.VESSEL_PROTOCOL_LOADING, body).then(callback);
    },
    async getVesselProtocolDischarge(id, callback){
        await genericService.getItem(urls.VESSEL_PROTOCOL_DISCHARGE, id).then(callback);
    },
    async calculateVesselProtocolDischarge(body, callback){
        await genericService.post(urls.VESSEL_PROTOCOL_DISCHARGE_CALCULATE, body).then(callback);
    },
    async updateVesselProtocolDischarge(body, callback){
        await genericService.put(urls.VESSEL_PROTOCOL_DISCHARGE, body).then(callback);
    },
    async addVesselProtocolDischarge(body, callback){
        await genericService.post(urls.VESSEL_PROTOCOL_DISCHARGE, body).then(callback);
    },
    async getVesselProtocolPrevisionalCommercialInfo(id, callback){
        await genericService.getItem(urls.VESSEL_PROTOCOL_PREVISIONAL_COMMERCIAL_INFO, id).then(callback);
    },
    async updateVesselProtocolPrevisionalCommercialInfo(body, callback){
        await genericService.put(urls.VESSEL_PROTOCOL_PREVISIONAL_COMMERCIAL_INFO, body).then(callback);
    },
    async addVesselProtocolPrevisionalCommercialInfo(body, callback){
        await genericService.post(urls.VESSEL_PROTOCOL_PREVISIONAL_COMMERCIAL_INFO, body).then(callback);
    },
    async getVesselProtocolFinalCommercialInfo(id, callback){
        await genericService.getItem(urls.VESSEL_PROTOCOL_FINAL_COMMERCIAL_INFO, id).then(callback);
    },
    async updateVesselProtocolFinalCommercialInfo(body, callback){
        await genericService.put(urls.VESSEL_PROTOCOL_FINAL_COMMERCIAL_INFO, body).then(callback);
    },
    async addVesselProtocolFinalCommercialInfo(body, callback){
        await genericService.post(urls.VESSEL_PROTOCOL_FINAL_COMMERCIAL_INFO, body).then(callback);
    },
    async updateVesselProtocolPayment(body, callback){
        await genericService.put(urls.VESSEL_PROTOCOL_PAYMENTS, body).then(callback);
    },
    async addVesselProtocolPayment(body, callback){
        await genericService.post(urls.VESSEL_PROTOCOL_PAYMENTS, body).then(callback);
    },
    async addVesselProtocolFinalCommercialDocument(body, callback){
        await genericService.post(urls.VESSEL_PROTOCOL_FINAL_COMMERCIAL_DOCUMENT, body).then(callback);
    },
    async updateVesselProtocolFinalCommercialDocument(body, callback){
        await genericService.put(urls.VESSEL_PROTOCOL_FINAL_COMMERCIAL_DOCUMENT, body).then(callback);
    },
    async getVesselProtocolVat(body, callback){
        await genericService.get(urls.MASTER_DATA_VAT, body).then(callback);
    },
    async calculateVesselProtocolPCI(body, callback){
        await genericService.post(urls.VESSEL_PROTOCOL_PCI_CALCULATION, body).then(callback);
    },
    async calculateVesselProtocolFCI(body, callback){
        await genericService.post(urls.VESSEL_PROTOCOL_FCI_CALCULATION, body).then(callback);
    },
    async getPreviewVesselProtocolReport(body, callback){
        await genericService.dowloadFile(urls.VESSEL_PROTOCOL_REPORT_PRINT, body).then(callback);
    },
    async saveVesselProtocolReport7(body, callback){
        await genericService.post(urls.VESSEL_PROTOCOL_REPORT_7, body).then(callback);
    },
    async saveVesselProtocolReport11(body, callback){
        await genericService.post(urls.VESSEL_PROTOCOL_REPORT_11, body).then(callback);
    },
    async saveVesselProtocolReport12(body, callback){
        await genericService.post(urls.VESSEL_PROTOCOL_REPORT_12, body).then(callback);
    },
    async saveVesselProtocolReport13(body, callback){
        await genericService.post(urls.VESSEL_PROTOCOL_REPORT_13, body).then(callback);
    },
    async saveVesselProtocolReport14(body, callback){
        await genericService.post(urls.VESSEL_PROTOCOL_REPORT_14, body).then(callback);
    },
    async saveVesselProtocolReport16(body, callback){
        await genericService.post(urls.VESSEL_PROTOCOL_REPORT_16, body).then(callback);
    },
    async saveVesselProtocolReport23(body, callback){
        await genericService.post(urls.VESSEL_PROTOCOL_REPORT_23, body).then(callback);
    },
    async saveVesselProtocolReport24(body, callback){
        await genericService.post(urls.VESSEL_PROTOCOL_REPORT_24, body).then(callback);
    },
    async saveVesselProtocolReport28(body, callback){
        await genericService.post(urls.VESSEL_PROTOCOL_REPORT_28, body).then(callback);
    },
    async saveVesselProtocolReport30(body, callback){
        await genericService.post(urls.VESSEL_PROTOCOL_REPORT_30, body).then(callback);
    },
    async saveVesselProtocolReport31(body, callback){
        await genericService.post(urls.VESSEL_PROTOCOL_REPORT_31, body).then(callback);
    },
    async saveVesselProtocolReport33(body, callback){
        await genericService.post(urls.VESSEL_PROTOCOL_REPORT_33, body).then(callback);
    },
    async saveVesselProtocolReport36(body, callback){
        await genericService.post(urls.VESSEL_PROTOCOL_REPORT_36, body).then(callback);
    },
    async saveVesselProtocolReport37(body, callback){
        await genericService.post(urls.VESSEL_PROTOCOL_REPORT_37, body).then(callback);
    },
    async saveVesselProtocolReport38(body, callback){
        await genericService.post(urls.VESSEL_PROTOCOL_REPORT_38, body).then(callback);
    },
    async saveVesselProtocolReport39(body, callback){
        await genericService.post(urls.VESSEL_PROTOCOL_REPORT_39, body).then(callback);
    },
    async saveVesselProtocolReport40(body, callback){
        await genericService.post(urls.VESSEL_PROTOCOL_REPORT_40, body).then(callback);
    },
    async saveVesselProtocolReport41(body, callback){
        await genericService.post(urls.VESSEL_PROTOCOL_REPORT_41, body).then(callback);
    },
    async saveVesselProtocolReport42(body, callback){
        await genericService.post(urls.VESSEL_PROTOCOL_REPORT_42, body).then(callback);
    },
    async saveVesselProtocolReport44(body, callback){
        await genericService.post(urls.VESSEL_PROTOCOL_REPORT_44, body).then(callback);
    },
    async saveVesselProtocolReport45(body, callback){
        await genericService.post(urls.VESSEL_PROTOCOL_REPORT_45, body).then(callback);
    },
    async saveVesselProtocolReport47(body, callback){
        await genericService.post(urls.VESSEL_PROTOCOL_REPORT_47, body).then(callback);
    },
    async saveVesselProtocolReport52(body, callback){
        await genericService.post(urls.VESSEL_PROTOCOL_REPORT_52, body).then(callback);
    },
    async saveVesselProtocolReport53(body, callback){
        await genericService.post(urls.VESSEL_PROTOCOL_REPORT_53, body).then(callback);
    },
    async saveVesselProtocolReport54(body, callback){
        await genericService.post(urls.VESSEL_PROTOCOL_REPORT_54, body).then(callback);
    },
    async saveVesselProtocolReport71(body, callback){
        await genericService.post(urls.VESSEL_PROTOCOL_REPORT_71, body).then(callback);
    },
    async saveVesselProtocolReport72(body, callback){
        await genericService.post(urls.VESSEL_PROTOCOL_REPORT_72, body).then(callback);
    },
    async saveVesselProtocolReport4(body, callback){
        await genericService.post(urls.VESSEL_PROTOCOL_REPORT_4, body).then(callback);
    },
    async printVesselProtocolReport4Excel(body, callback){
        await genericService.dowloadFile(urls.VESSEL_PROTOCOL_REPORT_4_EXCEL, body).then(callback);
    },
    async saveVesselProtocolReport57(body, callback){
        await genericService.post(urls.VESSEL_PROTOCOL_REPORT_57, body).then(callback);
    },
    async saveVesselProtocolIstanceReport(body, callback){
        await genericService.post(urls.VESSEL_PROTOCOL_ISTANCE_REPORT, body).then(callback);
    },
    async saveVesselProtocolPortualTaxReport(body, callback){
        await genericService.post(urls.VESSEL_PROTOCOL_REPORT_PORTUAL_TAX, body).then(callback);
    },
    async printVesselProtocolIstanceReport(body, callback){
        await genericService.dowloadFile(urls.VESSEL_PROTOCOL_ISTANCE_REPORT_PRINT, body).then(callback);
    },
    async printVesselProtocolIstanceReportExcel(body, callback){
        await genericService.dowloadFile(urls.VESSEL_PROTOCOL_ISTANCE_REPORT_PRINT_EXCEL, body).then(callback);
    },
    async getVesselProtocolGoodsDestination(body, callback){
        await genericService.get(urls.VESSEL_PROTOCOL_CI_GOODS_DESTINATION, body).then(callback);
    },
    async getVesselProtocolCustomsInformationBollaAida(body, callback){
        await genericService.getItem(urls.VESSEL_PROTOCOL_CUSTOMS_INFORMATION_BOLLA_AIDA, body).then(callback);
    },
    async searchVesselProtocolToMongoDB(body, callback){
        await genericService.post(urls.VESSEL_PROTOCOL_TO_MONGO_DB, body).then(callback);
    },
    async addDocumentVesselProtocolDocumentManager(body, callback){
        await genericService.post(urls.VESSEL_PROTOCOL_DOCUMENT_MANAGER, body).then(callback);
    },
    async downloadDocumentVesselProtocol(body, callback){
        await genericService.dowloadFile(urls.VESSEL_PROTOCOL_DOCUMENT_MANAGER_DOWNLOAD, body).then(callback);
    },
    async getAttachmentsByIdVesselProtocol(body, callback){
        await genericService.getItem(urls.VESSEL_PROTOCOL_ATTACHMENTS_BY_VESSEL_PROTOCOL_ID, body).then(callback);
    },
    async sendEmailVesselProtocol(body, callback){
        await genericService.post(urls.VESSEL_PROTOCOL_SEND_EMAIL, body).then(callback);
    },
    async sendEmailReport52(body, callback){
        await genericService.post(urls.VESSEL_PROTOCOL_SEND_EMAIL_REPORT_52, body).then(callback);
    },
    async sendEmailReport53(body, callback){
        await genericService.post(urls.VESSEL_PROTOCOL_SEND_EMAIL_REPORT_53, body).then(callback);
    },
    async checkValueReview(body, callback){
        await genericService.get(urls.VESSEL_PROTOCOL_CHECK_VALUE_REVIEW, body).then(callback);
    },
    async deleteAttachmentVesselProtocolDocumentManager(body, callback){
        await genericService.deleteBody(urls.VESSEL_PROTOCOL_ATTACHMENTS_DELETE_BY_ID, body.documentGuid, body).then(callback);
    },
    async sendEmailPaymentsVesselProtocol(id, body, callback){
        await genericService.post(urls.VESSEL_PROTOCOL_SEND_EMAIL_PAYMENTS + id, body).then(callback);
    },
    async getReportDataAddress(params, callback){
        await genericService.get(urls.VESSEL_PROTOCOL_REPORT_DATA_GET_ADDRESS, params).then(callback);
    },

    async printDischargeSimWeb(body, callback){
        await genericService.dowloadFile(urls.VESSEL_PROTOCOL_PRINT_DISCHARGE_REPORT, body).then(callback);
    },
    async printLoadingSimWeb(body, callback){
        await genericService.dowloadFile(urls.VESSEL_PROTOCOL_PRINT_LOADING_REPORT, body).then(callback);
    },
    async loadDischargeRawMaterialCheck(body, callback){
        await genericService.get(urls.RAW_MATERIAL_CHECK, body).then(callback);
    },
    async dischargeRawMaterialCheckAssociateNote(body, callback){
        await genericService.putNoId(urls.RAW_MATERIAL_CHECK_NOTES_ASSOCIATE, body).then(callback);
    },
    async createDischargeRawMaterialCheckNote(body, callback){
        await genericService.post(urls.RAW_MATERIAL_CHECK_NOTE, body).then(callback);
    },
    async loadDischargeRawMaterialCheckNote(body, callback){
        await genericService.get(urls.RAW_MATERIAL_CHECK_NOTE, body).then(callback);
    },
    async rawMaterialCheckImportAnalysisValues(body, callback){
        await genericService.putQueryParams(urls.RAW_MATERIAL_CHECK_IMPORT_ANALYSIS_VALUES, body).then(callback);
    },
    async updateRawMaterialCheck(body, callback){
        await genericService.putNoId(urls.RAW_MATERIAL_CHECK, body).then(callback);
    },
    async dischargeRawMaterialDownload(body, callback){
        await genericService.dowloadFile(urls.RAW_MATERIAL_CHECK_EXPORT_EXCEL, body).then(callback);
    },
    async loadDischargeTrackingByProtocolId(body, callback){
        await genericService.getItem(urls.DISCHARGE_TRACKING_BY_PROTOCOL_ID, body).then(callback);
    },
    async rawMaterialCheckCloneNotes(fromReferenceDate, toReferenceDate, callback){
        await genericService.post(urls.RAW_MATERIAL_CHECK_NOTE_CLONE + "?fromReferenceDate=" + fromReferenceDate + "&toReferenceDate=" + toReferenceDate, {}).then(callback);
    },
    async tributeResearchExportExcel(body, callback){
        await genericService.post(urls.VESSEL_PROTOCOL_TRIBUTE_RESEARCH_EXPORT_EXCEL, body).then(callback);
    },
    async printTributeResearchExcel(id, callback){
        await genericService.dowloadFile(urls.VESSEL_PROTOCOL_TRIBUTE_RESEARCH_EXCEL_PRINT, id).then(callback);
    },
    async protocolSearchExportExcel(body, callback){
        await genericService.post(urls.VESSEL_PROTOCOL_PROTOCOL_EXPORT_EXCEL, body).then(callback);
    },
    async printProtocolSearchExcel(id, callback){
        await genericService.dowloadFile(urls.VESSEL_PROTOCOL_PROTOCOL_EXPORT_EXCEL_PRINT, id).then(callback);
    },
    async updateVesselProtocolByLotId(id, callback){
        await genericService.put(urls.VESSEL_PROTOCOL, id).then(callback);
    },
    async getAttachmentsSchedulingByIdVesselProtocol(body, callback){
        await genericService.getItem(urls.VESSEL_PROTOCOL_SCHEDULING_ATTACHMENTS_BY_VESSEL_PROTOCOL_ID, body).then(callback);
    },
    async getVesselProtocolZipDocuments(id, callback){
        await genericService.dowloadFilePathVariable(urls.VESSEL_PROTOCOL_ZIP_DOCUMENTS ,id).then(callback);
    },
}